import { render } from "./ConactPage.vue?vue&type=template&id=1955985a&scoped=true"
import script from "./ConactPage.vue?vue&type=script&lang=js"
export * from "./ConactPage.vue?vue&type=script&lang=js"

import "./ConactPage.vue?vue&type=style&index=0&id=1955985a&scoped=true&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1955985a"]])

export default __exports__